
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
import { debounce as _debounce } from 'underscore';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import '@benmajor/jquery-touch-events';
import 'jquery-clickout';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el:                   false,
            $trigger:              false,

            time_transition_on:    0.6,
            time_transition_off:   0.3,

            deep_link:             false,
            $trigger_base:         false,
            page_title:            '',
            forceOpen:             false,


            global: false

        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'popup_window';
		this.$el 			= 	this.options.$el;
        this.$trigger       =   this.options.$trigger;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 && this.$trigger.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
        this.$win  = $(window);


        // attach to the body!!!!
        if( ! this.$el.parent().is( 'body' ) ){
            $('body').append( this.$el );
        }

    	this.$close     = this.$el.find( 'a.win-close' );
        this.$scroll    = this.$el.find( '.scroll-content' );
        this.$content   = this.$el.find( '.window-content' );
        this.$popup     = this.$el.find( '.window' );
        
    	this.addEvents( true );

        if ( this.options.forceOpen ){
            this.forceOpen()
        }
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$close.on( 'tap', (e)=>this.open(false,e) );
    		}
    		else{
    			this.$close.on( 'click', (e)=>this.open(false,e) );
    		}
            this.$el.find( '.window' ).on( 'clickout', ()=>this.open(false) );
            this.$trigger.on( 'click', (e)=>this.triggerWindow(e) );
		}
		else{
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$close.off( 'tap', (e)=>this.open(false,e) );
    		}
    		else{
    			this.$close.off( 'click', (e)=>this.open(false,e) );
    		}
            this.$trigger.off( 'click', (e)=>this.triggerWindow(e) );
            this.$el.find( '.window' ).off( 'clickout', ()=>this.open(false) );
		}
        this.debounceResize(b);
	}

    triggerWindow(e){
        e.preventDefault();
        let $a = $(e.currentTarget), $template = $a.find( 'template' );

        if ( $a.attr( 'data-template-id' ) ){
            $template = $( '#' + $a.attr( 'data-template-id' ) );
        }

        if ( $template.length > 0 ){
            this.addContent( true, $template.html() );
            this.setTitle( $template.attr( 'data-title' ) );
            this.open( true );
            this.deep_link( true, $a.attr( 'href' ), $a );

        }

        return false;
    }

    deep_link( b, url, $el ){
        if ( this.options.deep_link ){
            let title = this.options.page_title;
            if ( b ){
                if ( !this.options.forceOpen ){
                    title = $el.find( 'template' ).attr( 'data-title' );
                    this.main.barba_history_add( url, $el, title );
                }
                this.options.forceOpen = false
            }
            else{
                this.main.barba_history_add( this.options.$trigger_base.attr( 'href' ), this.options.$trigger_base, title )
            }
        }
    }

    addContent( b, html ){
        if ( b ){
            this.$content.html( html );
        }
        else{
            this.$content.html( '' );
        }
    }

    setTitle(str){
        if ( str ){
            this.$popup.find( '.title' ).html( str );
        }
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){

    }

    onComplete(b){
        if ( !b ){
            this.$el.removeClass( 'is-open' );
            this.addContent( false );
        }
    }

    //---------------------------------------- METHODS ---------------------------------------//
    forceOpen(){
        let url = document.location.href, $a;
        console.log( 'forceOpen, url = ' + url );
        this.$trigger.each( (i,el) =>{
            $a = $(el);
            if ( $a.attr( 'href' ) === url ){
                this.scrollPageTo( $a );
                $a.trigger( 'click' );
                return;
            }
        });
    }

    scrollPageTo( $a ){
        gsap.to(this.$win, {duration: 0, scrollTo: $a.offset().top - this.$win.height()/2 + $a.find( 'img' ).height()/2 });
    }

    open(b,e){

        if ( e ){
            e.preventDefault();
        }

        let t = gsap.timeline(), dy = 10;
    	if ( b ){
            this.$el.addClass( 'is-open' );
            this.$el.find( '.scroll-content' ).scrollTop(0);
            t.fromTo( this.$popup, { y: dy }, {y:0, ease:'power2.easeOut',duration: this.options.time_transition_on} );
			t.fromTo( this.$el, { opacity:0}, {opacity:1, ease:'power2.easeOut', duration: this.options.time_transition_on, onComplete: ()=>this.onComplete(b)}, "-=" + this.options.time_transition_on );
            disableBodyScroll( this.$scroll[0] );
    	}
    	else{
            t.fromTo( this.$popup, { y:0 }, {y: - dy, ease:'power2.easeOut',duration: this.options.time_transition_off} );
    		t.to( this.$el, {opacity:0, ease:'power2.easeOut', duration: this.options.time_transition_off, onComplete: ()=>this.onComplete(b) }, "-=" + this.options.time_transition_off );
            enableBodyScroll( this.$scroll[0] );

            this.deep_link( false );
    	}

        return false
    }

    destroy(){
		if ( this.$el.length > 0 && this.$trigger.length > 0  && !this.options.global ){
            this.addContent( false );
    		this.addEvents( false );
            this.$el.remove()
    	}
    }

}


